export default __webpack_public_path__ + "static/media/k3.5322a19a.jpg";